import { BoxProps, IconButton } from "@chakra-ui/react"
import React from "react"
import { productImageViews } from "../../../../../../common/constants/search-constants"
import { useBrandedTranslation } from "../../../../../../common/hooks/useBrandedTranslation"
import { ProductImageViewType } from "../../../../../../common/types/global"
import CustomTooltip from "../../../../../shared/CustomTooltip"
import { CImage, CTechnicalDrawing } from "../../../../../shared/Icons"

type Props = BoxProps & {
  imageView: ProductImageViewType
  handleImageToggle: (e: React.MouseEvent<HTMLElement>) => void
  handleImagePreload: () => void
}

const MainImageToggle = ({ imageView, handleImageToggle, handleImagePreload }: Props) => {
  const { t } = useBrandedTranslation()

  return (
    <CustomTooltip label={t("search-toggle-product-images-tooltip")}>
      <IconButton
        aria-label="Toggle product image view"
        color="black"
        icon={imageView === productImageViews.PRODUCT ? <CTechnicalDrawing /> : <CImage />}
        position="absolute"
        right={{ base: 0, sm: "6" }}
        top={{ base: 4, sm: "6" }}
        isRound
        display="none"
        className="action-button"
        zIndex="docked"
        onClick={handleImageToggle}
        onMouseEnter={handleImagePreload}
      />
    </CustomTooltip>
  )
}

export default MainImageToggle
